import React, { useState } from 'react'
import { Body, Box, H4 } from '../layout'
import { FlipCard } from '../widgets'
import { assetUrl } from '../../utilities'
import './LearnMore.css'

export const LearnMore = () => {
  const [teamLeaderDetails, setTeamLeaderDetails] = useState(false)
  const [facilitatorDetails, setFacilitatorDetails] = useState(false)

  return (
    <Box className="learn-more-container section-padding" gap={40} fullWidth>
      <FlipCard
        className="half-width"
        flipped={teamLeaderDetails}
        backRotate="6deg"
        front={
          <Front
            image={assetUrl('team-leader.png')}
            title="For Team Leaders"
            subtext="Run powerful team development sessions - yourself."
            onOpen={() => setTeamLeaderDetails(true)}
          />
        }
        back={
          <Back
            onClose={() => setTeamLeaderDetails(false)}
            text="For leaders or team members looking to improve their team performance Shivoo is plug-and-play ready, with rich tutorials and tips. Get your subscription, get your team together, and start your journey to High Performance."
          />
        }
      />
      <FlipCard
        className="half-width"
        flipped={facilitatorDetails}
        backRotate="-9deg"
        front={
          <Front
            image={assetUrl('facilitator.png')}
            title="For Facilitators"
            subtext="The conversations your team needs to have - happening in real time."
            onOpen={() => setFacilitatorDetails(true)}
          />
        }
        back={
          <Back
            onClose={() => setFacilitatorDetails(false)}
            text="Take your team workshops to the next level. Shivoo provokes your client teams to have the conversations they need to have. It provides real time measurement, shared sensemaking, and a framework for ongoing development. Best of all it can be done with no pre-work and 5 minutes setup!"
          />
        }
      />
    </Box>
  )
}

const Front = ({ image, title, subtext, onOpen }) => (
  <Box className="learn-more-flip-card" column onClick={onOpen} cursor="pointer">
    <Box
      background={`url(${image})`}
      backgroundSize="cover"
      width="100%"
      height={289}
    />
    <H4>{title}</H4>
    <Body align="center">{subtext}</Body>
    <button onClick={onOpen}>Learn more</button>
  </Box>
)

const Back = ({ text, onClose }) => (
  <Box
    className="learn-more-flip-card"
    background="var(--blue)"
    column
    container
  >
    <Box className="information" fullHeight grow alignItems="center">
      <Body>{text}</Body>
    </Box>
    <button onClick={onClose}>Close</button>
  </Box>
)